import { useMutation } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { addMeshExtenderToCart } from "../api/client";
import { useGlobalStore } from "../stores/globalStore";

export const useAddMeshExtender = () => {
    const { shoppingCart } = useGlobalStore(
        useShallow((state) => ({
            shoppingCart: state.shoppingCart,
        }))
    );

    const scId: string = shoppingCart?.id ?? "";
    const ocId: string = shoppingCart?.offerContainer?.[0]?.id ?? "";

    const { mutateAsync: addMeshExtender } = useMutation({
        mutationFn: ({ productId, productName, quantity }: { productId: string, productName: string, quantity: number }) => {
            return addMeshExtenderToCart({ scId, ocId, productId, productName, quantity });
        },
    });

    return addMeshExtender;
}